import React from 'react'
import Addclass from '../../Components/tutor/Addclass'

function Class() {
  return (
    <div>
      <Addclass/>
    </div>
  )
}

export default Class
